import react from "react";
import { useState } from "react";
import "./Docs.css";
import pdfIcon from "./pdfIcon.png";
import wordIcon from "./WORD.png";
import alfa from "./alfaatt.jpg";
import { Modal } from "react-bootstrap"; 


function Docs() {
  const [blockone, setblockone] = useState(true);
  const [blocktwo, setblocktwo] = useState(true);
  const [blockthree, setblockthree] = useState(true);
  const [showModal, setShowModal] = useState(false);

    
  const handleToggleBlock = (blockSetter) => {
    blockSetter(prevState => !prevState);
  };
         
  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  function Oblast({ pdfUrl }) {
    const handleClick = () => {
      window.open(pdfUrl, '_blank');
    };
          
    return (
      <div className="documents" onClick={handleClick}>
        Область аккредитации (Приложение к аттеатату № 134.00.6.1.761600.05.13)
        <img src={pdfIcon}  width="22px" height="25px" alt="логотип" />
      </div>
    );
}

  function Metodika({ pdfUrl }) {
    const handleClick = () => {
      window.open(pdfUrl, '_blank');
    };
          
    return (
      <div className="documents" onClick={handleClick}>
        Методика расчета стоимости работ по сертификации
        <img src={pdfIcon}  width="22px" height="25px" alt="логотип" />
      </div>
    );
}

  function Zayavka({ pdfUrl }) {
    const handleClick = () => {
      window.open(pdfUrl, '_blank');
    };
          
    return (
      <div className="documents" onClick={handleClick}>
        Форма заявки на проведение работ по сертификации (скачать)
        <img src={wordIcon}  width="22px" height="25px" alt="логотип" />
      </div>
    );
  }

  function Tablica({ pdfUrl }) {
    const handleClick = () => {
      window.open(pdfUrl, '_blank');
    };
          
    return (
      <div className="documents" onClick={handleClick}>
        Форма таблицы соответсвия изделия космической техники (скачать)
        <img src={wordIcon}  width="22px" height="25px" alt="логотип" />
      </div>
    );
  }

    return (
        <div className="contacts">
            <div className="info">
                <Oblast pdfUrl="../oblast.pdf" />
                <Zayavka pdfUrl="../zayavka.docx" />
                <Tablica pdfUrl="../tablica.docx" />
                <Metodika pdfUrl="../stoimost.pdf" />
                <div onClick={() => handleToggleBlock(setblockone)} className="documents">Перечень документов, устанавливающих требования к процедуре сертификации 
                    <div className="imag"  style={{ backgroundImage: blockone ? 'url("../plus.png")' : 'url("../minus.png")',}}></div>
                </div>
                <div className="docum"  style={{ display: blockone ? 'none' : 'block',}}>
                    <table>
                    <thead>
                    </thead>
                    <tbody>
                        <tr>
                            <td>ГОСТ Р ИСО/МЭК 17021-1-2017</td>
                            <td>Оценка соответствия. Требования к органам, проводящим аудит и сертификацию систем менеджмента. Часть 1. Требования</td>
                        </tr>
                        <tr>
                            <td>ГОСТ Р ИСО 19011-2021</td>
                            <td>Оценка соответствия. Руководящие указания по проведению аудита систем менеджмента</td>
                        </tr>
                        <tr>
                            <td>ФСС КТ. РД 1.01-2006</td>
                            <td>Федеральная система сертификации космической техники. Основные положения</td>
                        </tr>
                        <tr>
                            <td>ФСС КТ. РД 1.02-2006</td>
                            <td>Федеральная система сертификации космической техники. Положение о центральном (руководящем) органе</td>
                        </tr>
                        <tr>
                            <td>ФСС КТ. РД 1.03-2006</td>
                            <td>Федеральная система сертификации космической техники. Положение о реестре ФСС КТ</td>
                        </tr>
                        <tr>
                            <td>ФСС КТ. РД 1.04-2006</td>
                            <td>Федеральная система сертификации космической техники. Положение о знаке соответствия</td>
                        </tr>
                        <tr>
                            <td>ФСС КТ. РД 2.03-2006</td>
                            <td>Федеральная система сертификации космической техники. Положение об органе по сертификации систем менеджмента качества и порядке его аккредитации</td>
                        </tr>
                        <tr>
                            <td>ФСС КТ. РД 3.02-2006</td>
                            <td>Федеральная система сертификации космической техники. Положение о порядке сертификации систем менеджмента качества</td>
                        </tr>
                        <tr>
                            <td>ФСС КТ. РД 3.03-2006</td>
                            <td>Федеральная система сертификации космической техники. Положение о порядке сертификации космических услуг</td>
                        </tr>
                        <tr>
                            <td>ФСС КТ. РД 4.01-2006</td>
                            <td>Федеральная система сертификации космической техники. Положение об экспертах</td>
                        </tr>
                        <tr>
                            <td>ГОСТ Р ИСО 9001-2015</td>
                            <td>Системы менеджмента качества. Требования</td>
                        </tr>
                        <tr>
                            <td>ГОСТ Р 58876-2020</td>
                            <td>Системы менеджмента качества организаций авиационной, космической и оборонной отраслей промышленности. Требования</td>
                        </tr>
                        <tr>
                            <td>ГОСТ Р ЕН 9110–2011</td>
                            <td>Системы менеджмента качества. Требования к организациям технического обслуживания авиационной техники</td>
                        </tr>
                        <tr>
                            <td>ГОСТ Р 58338-2018 (взамен ГОСТ Р ЕН 9120-2011)</td>
                            <td>Системы менеджмента качества организаций авиационной, космической и оборонной промышленности. Требования к дистрибьюторам продукции</td>
                        </tr>
                        <tr>
                            <td>ГОСТ РВ 0015-002-2020</td>
                            <td>Система разработки и постановки продукции на производство военной техники. Системы менеджмента качества. Требования</td>
                        </tr>
                        <tr>
                            <td>ГОСТ РВ 0015-003-2017</td>
                            <td>Система разработки и постановки на производство военной техники. Порядок проверки систем менеджмента качества организаций, поставляющих военную продукцию</td>
                        </tr>
                        <tr>
                            <td>РК-11-КТ</td>
                            <td>Положение о порядке создания, производства и эксплуатации (применения) космических комплексов </td>
                        </tr>
                        <tr>
                            <td>ОСТ 134-1028-2012 с изм. 2</td>
                            <td>Ракетно-космическая техника. Требования к системам менеджмента качества предприятий, участвующих в создании, производстве и эксплуатации изделий</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div onClick={() => handleToggleBlock(setblocktwo)} className="documents">Права и обязанности заявителей, связанных с осуществлением работ по сертификации
                    <div className="imag"  style={{ backgroundImage: blocktwo ? 'url("../plus.png")' : 'url("../minus.png")',}}></div>
                </div>
                <div className="description"  style={{ display: blocktwo ? 'none' : 'block',}}>
                      <p><b>Права заявителя:</b><br></br>
                      •  Право на получение информации о требованиях к сертификации космической техники и порядке ее проведения.<br></br>
                      •  Право на представление документов и информации, необходимой для проведения процедуры сертификации космической техники.<br></br>
                      •  Право на получение сертификата соответствия в случае успешного прохождения процедуры сертификации.<br></br>
                      <b>Обязанности заявителя:</b><br></br>
                      •  Предоставление всех необходимых документов и информации для проведения процедуры сертификации космической техники.<br></br>
                      •  Представление космической техники для проведения испытаний и проверок соответствия.<br></br>
                      •  Обеспечение выполнения всех требований и норм, связанных с процедурой сертификации космической техники.<br></br>
                      • Оформление таблицы соответствия изделия КТ требованиям нормативно-технических документов с указанием номенклатуры доказательной документации 
                      по каждому оцениваемому параметру; <br></br>
                      • Определение перечня покупных комплектующих изделий сертифицируемого изделия и обеспечение наличия сертификатов на эти составные части; <br></br>
                      • Разработка и внедрение системы менеджмента качества на всех этапах жизненного цикла изделия в соответствии с установленными требованиями; <br></br>
                      • Создание план-графика разработки (изготовления) и поэтапной оценки соответствия изделия с указанием сроков завершения работ и 
                      оформления доказательной документации.<br></br>
                      Кроме того, заявитель также обязан соблюдать следующие правила:<br></br>
                      • Следовать инструкциям и рекомендациям органа по сертификации в процессе сертификации космической техники.<br></br>
                      • Сообщать об изменениях в проекте КТ, которые могут повлиять на ее соответствие требованиям сертификации.<br></br>
                      • Соблюдать правила безопасности и технические нормы при проведении работ по сертификации космической техники.<br></br>
                      Нарушение правил и обязанностей заявителя может привести к отказу в выдаче сертификата соответствия космической техники или его аннулированию
                      после выдачи.
                     </p>
                </div>
                <div onClick={() => handleToggleBlock(setblockthree)} className="documents">Правила рассмотрения жалоб и аппеляций на решения органа по сертификации 
                    <div className="imag"  style={{ backgroundImage: blockthree ? 'url("../plus.png")' : 'url("../minus.png")',}}></div>
                </div>
                <div className="description"  style={{ display: blockthree ? 'none' : 'block',}}>
                      <p><b>Правила рассмотрения жалоб и аппеляций на решения органа по сертификации в системе федеральной системы сертификации космической техники:</b><br></br>
                            Жалоба или аппеляция должна быть подана в письменной форме органу по сертификации в течение 10 рабочих дней с момента получения решения.<br></br>
                            Жалоба или аппеляция должна содержать полное описание причин, по которым заявитель не согласен с решением органа по сертификации, а также доказательства, подтверждающие его позицию.<br></br>
                            Орган по сертификации должен незамедлительно сообщить заявителю о получении жалобы или аппеляции.<br></br>
                            Орган по сертификации должен провести внутреннее расследование жалобы или аппеляции, привлекая к этому процессу компетентных специалистов.<br></br>
                            Орган по сертификации должен сообщить заявителю о результатах расследования жалобы или аппеляции в течение 30 рабочих дней с момента ее получения.<br></br>
                            Если заявитель не удовлетворен результатами расследования жалобы или аппеляции, он может обратиться в центр сертификации РКТ при ЦНИИМашиностроения (исполняет функции центрального орагана ФСС КТ).<br></br>
                            Решение центра сертификации РКТ при ЦНИИМАШиностроения является окончательным и обжалованию не подлежит.</p>
                </div>
            </div>
            <div className="AlfaAkk">
                <h3>Аттестат аккредитации  ООО НПП «Альфа-Космос»</h3>
                <p>Аттестат аккредитации органа по сертификации ООО НПП "Альфа-Космос" сохраняет своё действие в соответствии с пунктом 22 статьи 1 ФЗ от 29.07.2018 г. №263-ФЗ </p>
                <img
                  src={alfa}
                  alt="аттестат"
                  onClick={handleShowModal}
          ></img>
               
            </div>
            <Modal show={showModal} onClick={handleCloseModal}>
              <Modal.Header closeButton>
              </Modal.Header>
              <Modal.Body>
                <img className="zoom" src={alfa} alt="аттестат" style={{ width: "50%" }}></img>
              </Modal.Body>
            </Modal>
        </div>
    )
}

export default Docs;



